import { useState, useEffect } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { DollarSign, TrendingUp, Clock } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function RevenueTile() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadSummary() {
      try {
        const response = await fetch(`${API_URL}/api/invoices/summary`, {
          credentials: 'include'
        });
        if (response.ok) {
          const result = await response.json();
          setData(result);
        }
      } catch (error) {
        console.error('Failed to load invoice summary:', error);
      } finally {
        setLoading(false);
      }
    }
    loadSummary();
  }, []);

  if (loading) {
    return (
      <Card className="bg-slate-800/50 border-slate-700">
        <CardContent className="p-4">
          <div className="animate-pulse grid grid-cols-2 gap-4">
            <div className="h-16 bg-slate-700 rounded"></div>
            <div className="h-16 bg-slate-700 rounded"></div>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!data) return null;

  return (
    <Card className="bg-slate-800/50 border-slate-700" data-testid="revenue-tile">
      <CardContent className="p-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-slate-900/50 rounded-lg p-4">
            <div className="flex items-center gap-2 text-slate-400 text-xs mb-1">
              <TrendingUp className="w-3 h-3" />
              Revenue this month
            </div>
            <div className="text-xl font-bold text-green-400 flex items-center">
              <DollarSign className="w-5 h-5" />
              {data.monthPaidTotal.toFixed(2)}
            </div>
          </div>
          <div className="bg-slate-900/50 rounded-lg p-4">
            <div className="flex items-center gap-2 text-slate-400 text-xs mb-1">
              <Clock className="w-3 h-3" />
              Outstanding
            </div>
            <div className="text-xl font-bold text-yellow-400 flex items-center">
              <DollarSign className="w-5 h-5" />
              {data.outstandingTotal.toFixed(2)}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default RevenueTile;
